import { useQuery } from "react-query";
import {
  GetDataByTermsRequest,
  PatientStepRecords,
  GetPatientStepRecordsResponse,
} from "types";
import { get } from "lib/axios";
import { useQueryClient } from "react-query";
import { useEffect } from "react";
import { formatDateToString } from "utils";

const getPatientStepRecords = async (
  patientId: string,
  params: GetDataByTermsRequest
): Promise<PatientStepRecords> => {
  const { data } = await get<GetPatientStepRecordsResponse>(
    `/patients/${patientId}/health_record/step/daily`,
    {
      params: {
        from_date: formatDateToString(params.from_date),
        to_date: formatDateToString(params.to_date),
      },
    }
  );

  return data.values.map((data) => {
    return [Date.parse(data.date), data.value];
  });
};

export const usePatientStepRecordsQuery = (
  patientId: string,
  params: GetDataByTermsRequest
) => {
  return useQuery(
    [`healthRecord/step`],
    () => {
      return getPatientStepRecords(patientId, params);
    },
    {
      retry: false,
      staleTime: 1000 * 60 * 5,
    }
  );
};

export const useRemoveCacheOnUnMount = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    return () => {
      queryClient.removeQueries("healthRecord/step");
    };
  }, [queryClient]);
};
